import React from "react";

import Video from "./video";

class VideoContainer extends React.Component {
  constructor(props) {
    super(props);

    // arbitrary business logic
    this.fakeData = "fake data";
  }

  render() {
    return (
      <Video
        type={this.props.data.videoType}
        url={this.props.data.videoFile.fields.file.url}
      />
    );
  }
}
export default VideoContainer;
